import { css } from '@emotion/react';
import ReactPlayer from 'react-player/lazy';

import { MCQ_MEDIA_RESOURCES_TYPES } from '@didaskill/domain/assignments/constants';
import type { McqResource } from '@didaskill/domain/assignments/types';
import { DEFAULT_VIDEO_ASPECT_RATIO } from '@didaskill/domain/html/constants';
import { AudioPlayer } from '@didaskill/ui/design-system';

export const renderResources = (resource: McqResource, { width }: { width: number }) => {
  switch (resource.type) {
    case MCQ_MEDIA_RESOURCES_TYPES.IMAGE:
      return (
        <img
          css={css`
            width: ${width}px;
            border-radius: 8px;
          `}
          src={resource.params.upload.href}
          alt={resource.params.alt}
        />
      );
    case MCQ_MEDIA_RESOURCES_TYPES.AUDIO:
      return <AudioPlayer src={resource.params.upload.href} />;
    case MCQ_MEDIA_RESOURCES_TYPES.VIDEO:
      return (
        <ReactPlayer
          width={width}
          height={width / DEFAULT_VIDEO_ASPECT_RATIO}
          url={resource.params.href}
          controls
        />
      );
    default:
      return null;
  }
};
